module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8017.8ee2b0d5.png";